// public/js/utils/escape.js
// HTML-escape user-controlled strings before interpolating them into innerHTML.
// Use for any value that can originate from user/device input: asset
// label/reference/serial, deviceId, tenant names, slot labels, field options, …
export function escapeHtml(s) {
  return String(s ?? '').replace(/[&<>"']/g, c => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
  }[c]));
}
